<template>
  <div id="home">
    <div id="header">
      <img src="@/assets/logo.png" class="logo"/>
      <h1>Willmack.io</h1>
    </div>
    <div id="about">
      <p>
        Willmack provides custom software engineering services, including:
      </p>
      <ul>
        <li>Prototyping</li>
        <li>Web services</li>
        <li>Mobile apps</li>
        <li>Machine learning</li>
        <li>Architecture consulting</li>
      </ul>
      <p class="contact">
        <a :href="contactUrl" class="contact">Contact</a>
      </p>
    </div>
  </div>
</template>

<script>
const MT_PRE = 'contact@'

export default {
  name: 'home',

  data () {
    return {
      contactUrl: 'mailt' + 'o:' + MT_PRE + 'willmack.io'
    }
  }
}
</script>

<style>
#home {
  padding: 0 1em 1em 1em;
  border: 2px solid #eee;
  box-shadow: 0 0 2em rgba(0, 0, 0, 0.04);
}

h1 {
  font-family: "Roboto Slab", serif;
  font-weight: 700;
  font-size: 1.7em;
}

#header {
  position: relative;
  padding: 0.5em 0 0 6em;
  box-sizing: border-box;
}

#header>.logo {
  width: 5em;
  position: absolute;
  left: 0;
  top: 0;
}

p.contact {
  text-align: center;
}

a.contact {
  display: inline-block;
  margin: 0 auto;
  background: #ff4600;
  color: white;
  border-radius: 0.3em;
  text-align: center;
  padding: 0.2em 0.5em;
  text-decoration: none;
}
</style>